import React from "react";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";

const SCloseIcon = styled(CloseIcon)`
  font-size: 18px;
  opacity: 0.6;
`;

type Props = {
  onClick: VoidFunction;
};

const ClearButton: React.FC<Props> = ({ onClick }) => {
  return (
    <InputAdornment position="end">
      <IconButton size="small" onClick={onClick} tabIndex={-1}>
        <SCloseIcon />
      </IconButton>
    </InputAdornment>
  );
};

export default ClearButton;
